import type { InspectionType } from '@/common/inspection';
import { axios } from '@/lib/utils/axios';

import { getResponse } from '../common';
import { API_URLS } from '../query.client';

export type AddInspectionSuccessResponseType = InspectionType;

export async function addInspection(
	assetId: string,
	payload: Omit<InspectionType, 'id'>,
): Promise<AddInspectionSuccessResponseType | null> {
	const response = await axios.post(`${API_URLS.INSPECTION.INDEX(assetId)}`, payload);
	return getResponse<AddInspectionSuccessResponseType>(response.data);
}
